import api from './apiClient';

export const organizersAPI = {
  getOrganizers: async () => {
    const response = await api.get('/api/organizers');
    return response.data;
  },
  getOrganizerById: async (id) => {
    const response = await api.get(`/api/organizers/${id}`);
    return response.data;
  },
  createOrganizer: async (organizerData) => {
    const response = await api.post('/api/organizers', organizerData);
    return response.data;
  },
  updateOrganizer: async (id, organizerData) => {
    const response = await api.post(`/api/organizers/${id}`, organizerData);
    return response.data;
  },
  deleteOrganizer: async (id) => {
    await api.post(`/api/organizers/${id}/delete`, {});
  },
};
